// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './helpers/router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import VueGtag from 'vue-gtag'
import 'vuetify/dist/vuetify.min.css'
import { description, version, author } from '../package'
import VcSocialBar from 'vc-social-bar'
import 'vc-social-bar/dist/lib/vc-social-bar.min.css'

import OriginalUrlsSupport from './helpers/original-urls-support'

import config from './helpers/config'
import lang from './helpers/lang'
import colors from './helpers/colors'
import methods from './helpers/methods'
import events from './helpers/events'
import cache from './helpers/cache'

import PageHeader from './components/page-header'
import BandMembers from './components/band-members'
import Grid from './components/grid'
import ChevronRight from './components/chevron-right'
import Warning from './components/warning'

Vue.use(VueAxios, axios)
Vue.use(Vuetify)
Vue.use(VueGtag, {
  config: {
    id: config.googleAnalyticsId,
    params: {
      send_page_view: false
    }
  }
}, router)

Vue.component('vc-social-bar', VcSocialBar)
Vue.component('page-header', PageHeader)
Vue.component('band-members', BandMembers)
Vue.component('grid', Grid)
Vue.component('chevron-right', ChevronRight)
Vue.component('warning', Warning)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  data () {
    return {
      lang,
      cache,
      colors,
      config,
      description,
      version,
      author,
      ready: false,
      routes: [],
      years: [],
      genres: [],
      regions: [],
      regionsMap: {},
      releases: [],
      alphanumeric: null,
      currentResource: null
    }
  },
  mixins: [
    methods
  ],
  components: {
    App
  },
  template: '<App/>',
  created () {
    const originalUrlsSupport = new OriginalUrlsSupport()
    originalUrlsSupport.hrefContains('.php') ? originalUrlsSupport.init() : this.addAxiosInterceptors()
  },
  watch: {
    /**
     * Generic $route watcher
     */
    $route () {
      this.emitRouteChange()
    }
  },
  methods: {
    /**
     * Set Axios interceptors
     * @method addAxiosInterceptors
     * @return {void}
     */
    addAxiosInterceptors () {
      const ajax = events.ajax
      const interceptors = this.$http.interceptors
      interceptors.request.use(config => {
        this.$emit(ajax, true)
        return config
      }, function (error) {
        return Promise.reject(error)
      })

      interceptors.response.use(response => {
        window.scrollTo(0, 0)
        if (response.data.status === 'success') {
          const path = this.$route.path.replace('/', '').split('/')
          let slug = path.length === 1 ? 'page' : path[0]
          let id = path.length === 1 ? path[0] : path[1]
          if (id === '') {
            id = 'index'
          }
          if (this.ready) {
            this.addPageToCache(slug, id, response.data.payload)
          }
          this.$emit(ajax, false)
          return response
        }
        this.$emit(ajax, false)
        this.$emit(events.error, false)
      }, (error) => {
        return Promise.reject(error)
      })
      this.bootstrapData()
    },
    /**
     * Start bootstrapping the data
     * @method bootstrapData
     * @return {void}
     */
    bootstrapData () {
      this.getApiRoutes()
      this.setDocumentTitle()
    },
    /**
     * Get all of the API routes
     * @method getApiRoutes
     * @return {void}
     */
    getApiRoutes () {
      const root = this.config.root
      this.$http(root)
        .then(response => {
          const routes = []
          response.data.payload.routes.forEach(route => {
            route.url = root + route.url
            routes.push(route)
          })
          this.routes = routes
          this.getYears()
        })
    },
    /**
     * Get /years
     * @method getYears
     * @return {void}
     */
    getYears () {
      this.$http(this.routes[11].url)
        .then(response => {
          this.years = response.data.payload
          this.getAlphanumericEntries()
        })
    },
    /**
     * Get /alphanumeric
     * @method getAlphanumericEntries
     * @return {void}
     */
    getAlphanumericEntries () {
      this.$http(this.routes[1].url)
        .then(response => {
          this.alphanumeric = response.data.payload
          this.getGenres()
        })
    },
    /**
     * Get /genres
     * @method getGenres
     * @return {void}
     */
    getGenres () {
      this.$http(this.routes[9].url)
        .then(response => {
          this.genres = response.data.payload
          this.getRegions()
        })
    },
    /**
     * Get /regions
     * @method getGenres
     * @return {void}
     */
    getRegions () {
      this.$http(this.routes[13].url)
        .then(response => {
          this.regions = response.data.payload.regions
          this.regionsMap = response.data.payload.map
          this.getReleases()
        })
    },
    /**
     * Get /releases
     * @method getGenres
     * @return {void}
     */
    getReleases () {
      this.$http(this.routes[15].url)
        .then(response => {
          this.releases = response.data.payload
          this.ready = true
          this.$emit(events.ready, true)
        })
    }
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js